import React from "react";
import { Field as RJSFField, FieldProps } from "@rjsf/utils";
import { Checkbox, Field, Input, makeStyles, tokens, CheckboxOnChangeData } from "@fluentui/react-components";
import { RegisterControl } from "@eavfw/apps";
import { registerInputControlDesignerField } from "@eavfw/quickform-designer";
import type { JSONSchema7 } from "json-schema";

const useStyles = makeStyles({
    row: { marginBottom: tokens.spacingVerticalS },
    group: { display: "flex", flexDirection: "column", gap: tokens.spacingVerticalXS }
});

export const ImagesPerRowField: RJSFField = ({
    formData = {},
    onChange,
    schema,
}) => {
    const styles = useStyles();

    const desktopSchema = schema?.properties?.imagesPerRowDesktop as JSONSchema7 || {};
    const tabletSchema = schema?.properties?.imagesPerRowTablet as JSONSchema7 || {};
    const phoneSchema = schema?.properties?.imagesPerRowPhone as JSONSchema7 || {};

    const {
        customImagesPerRow = false,
        imagesPerRowDesktop = desktopSchema.default ?? 8,
        imagesPerRowTablet = tabletSchema.default ?? 4,
        imagesPerRowPhone = phoneSchema.default ?? 2,
    } = formData;

    const handleCheckbox = (_: any, data: CheckboxOnChangeData) => {
        onChange({
            ...formData,
            customImagesPerRow: !!data.checked,
        });
    };

    const handleChange = (key: string) => (_: any, data: { value: string }) => {
        onChange({
            ...formData,
            [key]: Number(data.value),
        });
    };

    return (
        <div className={styles.group}>
            <Field label={schema.title}>
                <Checkbox
                    checked={!!customImagesPerRow}
                    onChange={handleCheckbox}
                    label="Specify images per row?"
                />
            </Field>
            {customImagesPerRow && (
                <>
                    <Field label="Images per row (Desktop):" className={styles.row}>
                        <Input
                            type="number"
                            min={desktopSchema.minimum}
                            max={desktopSchema.maximum}
                            value={imagesPerRowDesktop?.toString()}
                            onChange={handleChange("imagesPerRowDesktop")}
                        />
                    </Field>
                    <Field label="Images per row (Tablet):" className={styles.row}>
                        <Input
                            type="number"
                            min={tabletSchema.minimum}
                            max={tabletSchema.maximum}
                            value={imagesPerRowTablet?.toString()}
                            onChange={handleChange("imagesPerRowTablet")}
                        />
                    </Field>
                    <Field label="Images per row (Phone):" className={styles.row}>
                        <Input
                            type="number"
                            min={phoneSchema.minimum}
                            max={phoneSchema.maximum}
                            value={imagesPerRowPhone?.toString()}
                            onChange={handleChange("imagesPerRowPhone")}
                        />
                    </Field>
                </>
            )}
        </div>
    );
};

registerInputControlDesignerField("ImagesPerRowField", ImagesPerRowField);
RegisterControl("ImagesPerRowField", ImagesPerRowField);